import type { SlashCommand } from '~/components/chat/ChatBox'

const TASK_ID_PATTERN = /\bTaskId\s*:/i

export const CHAT_SLASH_COMMANDS: SlashCommand[] = [
  {
    id: 'code-review',
    command: '/code-review',
    label: 'Code review',
    description: 'Review code, generated output, or task diffs',
    actions: [
      {
        id: 'general',
        label: 'Review General',
        description: 'Broad review',
        message: '/code-review: Review General'
      },
      {
        id: 'best-practices',
        label: 'Review For Best Practices',
        description: 'Best-practice review',
        message: '/code-review: Review For Best Practices'
      },
      {
        id: 'security',
        label: 'Review For Security Vulnerabilities',
        description: 'Security review',
        message: '/code-review: Review For Security Vulnerabilities'
      },
      {
        id: 'transformations',
        label: 'Review Transformations',
        description: 'Transformation review',
        message: '/code-review: Review Transformations'
      },
      {
        id: 'error-handling',
        label: 'Review Error Handling',
        description: 'Error-handling review',
        message: '/code-review: Review Error Handling'
      }
    ]
  }
]

export function appendCodeReviewTaskId(message: string, taskId: number): string {
  if (TASK_ID_PATTERN.test(message)) {
    return message
  }
  return `${message} TaskId: ${taskId}`
}

export function getChatSlashCommands({
  codeReviewTaskId
}: { codeReviewTaskId?: number | null } = {}): SlashCommand[] {
  if (codeReviewTaskId == null) {
    return CHAT_SLASH_COMMANDS
  }

  return CHAT_SLASH_COMMANDS.map(command => {
    if (command.id !== 'code-review') {
      return command
    }

    return {
      ...command,
      actions: command.actions.map(action => ({
        ...action,
        message: appendCodeReviewTaskId(action.message, codeReviewTaskId)
      }))
    }
  })
}
